import { FormType } from '../../../form-types';
import { DosableLDNQuestionFieldAnswers } from './questions';

export const dosableldn: FormType<DosableLDNQuestionFieldAnswers> = {
  name: 'Low Dose Naltrexone (LDN) Questionnaire',
  questions: [
    {
      key: 'ldn_sexAssignedAtBirth',
      next: {
        condition: { 'ldn_sexAssignedAtBirth.male': true },
        key: 'd_ldn_weightAndHeight2025',
        els: 'ldn_pregnancy'
      }
    },
    {
      key: 'ldn_pregnancy',
      next: {
        condition: { 'ldn_pregnancy.yes': true },
        key: 'ldn_ineligible',
        els: 'ldn_pregnancyConsent'
      }
    },
    {
      key: 'ldn_pregnancyConsent',
      next: {
        condition: { 'ldn_pregnancyConsent.non_consent': true },
        key: 'ldn_ineligible',
        els: 'd_ldn_weightAndHeight2025'
      }
    },
    'd_ldn_weightAndHeight2025',
    {
      key: 'd_ldn_dosable_acknowledgment',
      next: {
        condition: {
          'd_ldn_dosable_acknowledgment.consent': true
        },
        key: 'd_ldn_primarySymptoms',
        els: 'ldn_ineligible'
      }
    },
    {
      key: 'd_ldn_primarySymptoms',
      next: {
        condition: {
          'd_ldn_primarySymptoms.other': true
        },
        key: 'd_ldn_primarySymptomsOther',
        els: 'ldn_symptomsOnset'
      }
    },
    'd_ldn_primarySymptomsOther',

    'ldn_symptomsOnset',

    {
      key: 'ldn_inflammatoryConditions',
      next: {
        condition: { 'ldn_inflammatoryConditions.other': true },
        key: 'ldn_inflammatoryConditionsOther',
        els: 'd_ldn_triggers'
      }
    },
    'ldn_inflammatoryConditionsOther',
    {
      key: 'd_ldn_triggers',
      next: {
        condition: { 'd_ldn_triggers.other': true },
        key: 'd_ldn_triggersOther',
        els: 'd_ldn_priorTreatments'
      }
    },
    'd_ldn_triggersOther',
    'd_ldn_priorTreatments',
    {
      key: 'ldn_takenNaltrexoneBefore',
      next: {
        condition: { 'ldn_takenNaltrexoneBefore.yes': true },
        key: 'ldn_respondedWellToNaltrexone',
        els: 'ldn_currentOpioids'
      }
    },
    'ldn_respondedWellToNaltrexone',
    {
      key: 'ldn_sideEffectsToNaltrexone',
      next: {
        condition: { 'ldn_sideEffectsToNaltrexone.yes': true },
        key: 'ldn_sideEffectsToNaltrexoneDetails',
        els: 'ldn_currentOpioids'
      }
    },
    'ldn_sideEffectsToNaltrexoneDetails',
    {
      key: 'ldn_currentOpioids',
      next: {
        condition: { 'ldn_currentOpioids.yes': true },
        key: 'ldn_ineligible',
        els: 'ldn_opioidUseDisorder'
      }
    },
    {
      key: 'ldn_opioidUseDisorder',
      next: {
        condition: { 'ldn_opioidUseDisorder.yes': true },
        key: 'ldn_ineligible',
        els: 'ldn_liverKidneyDisease'
      }
    },
    {
      key: 'ldn_liverKidneyDisease',
      next: {
        condition: { 'ldn_liverKidneyDisease.yes': true },
        key: 'ldn_ineligible',
        els: 'ldn_mentalHealthHistory'
      }
    },
    {
      key: 'ldn_mentalHealthHistory',
      next: {
        condition: { 'ldn_mentalHealthHistory.yes': true },
        key: 'ldn_ineligible',
        els: 'ldn_additionalInfo'
      }
    },
    'ldn_additionalInfo',
    {
      key: 'd_ldn_consent',
      next: {
        condition: { 'd_ldn_consent.non_consent': true },
        key: 'ldn_ineligible',
        els: 'ldn_complete'
      }
    },
    'ldn_complete',
    'ldn_ineligible'
  ]
};
